import { render, staticRenderFns } from "./auditParkingSpaceApply.vue?vue&type=template&id=52dcf12a&scoped=true"
import script from "./auditParkingSpaceApply.vue?vue&type=script&lang=js"
export * from "./auditParkingSpaceApply.vue?vue&type=script&lang=js"
import style0 from "./auditParkingSpaceApply.vue?vue&type=style&index=0&id=52dcf12a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52dcf12a",
  null
  
)

export default component.exports